import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from "react";
import { connect } from "react-redux";
import actions from "../store/actions/bookTable/actions";
import * as asyncActions from "../store/actions/bookTable/asyncActions";
import bindActionCreators from "@magento/peregrine/lib/util/bindActionCreators";
const BookTableContext = createContext();
const BookTableContextProvider = props => {
  const {
    actions,
    asyncActions,
    bookTableState,
    children
  } = props;
  const bookTableApi = useMemo(() => _objectSpread({
    actions
  }, asyncActions), [actions, asyncActions]);
  const contextValue = useMemo(() => [bookTableState, bookTableApi], [bookTableApi, bookTableState]);
  return /*#__PURE__*/React.createElement(BookTableContext.Provider, {
    value: contextValue
  }, children);
};
const mapStateToProps = _ref => {
  let {
    bookTable
  } = _ref;
  return {
    bookTableState: bookTable
  };
};
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  asyncActions: bindActionCreators(asyncActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(BookTableContextProvider);
export const useBookTableContext = () => useContext(BookTableContext);